import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-WhiteOvalShape",
  "use": "svg-icon-WhiteOvalShape-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-WhiteOvalShape\"><path d=\"M23.5 12c0 6.351-5.149 11.5-11.5 11.5S.5 18.351.5 12 5.649.5 12 .5 23.5 5.649 23.5 12z\" fill=\"#fff\" stroke=\"#dadee6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol